import React, { useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logoutUser } from "../../redux/actions/authActions";
import Spinner from "../common/Spinner";



function LogOut({
    logoutUser,
    history,
    ...props
}) {
    useEffect(() => {
        logoutUser().then(() => {
            history.push("/login");
        });
        document.title = "Log out | JustGoRide";
    }, []);

    return (
        <Spinner message={"Logging out..."} /> 
    );
}

LogOut.propTypes =
{
    logoutUser: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    logoutUser
}

export default connect(mapStateToProps, mapDispatchToProps)(LogOut); 


// WEBPACK FOOTER //
// ./src/components/user/LogOut.js